import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import _inheritsLoose from "@babel/runtime/helpers/esm/inheritsLoose";
var _excluded = ["as", "children", "className", "closed", "transitionOnAppear", "forwardedRef"];
import React, { forwardRef, Component } from 'react';
var SlideDownContent = /*#__PURE__*/function (_Component) {
  _inheritsLoose(SlideDownContent, _Component);
  function SlideDownContent(props) {
    var _this;
    _this = _Component.call(this, props) || this;
    _this.outerRef = null;
    _this.handleRef = function (ref) {
      /* Handle both the internal and forwardedRef and maintain correct typings */
      _this.outerRef = ref;
      if (_this.props.forwardedRef) {
        if (typeof _this.props.forwardedRef === 'function') {
          _this.props.forwardedRef(ref);
        } else if (typeof _this.props.forwardedRef === 'object') {
          var forwardedRef = _this.props.forwardedRef;
          forwardedRef.current = ref;
        } else {
          throw new Error("Invalid forwardedRef " + _this.props.forwardedRef);
        }
      }
    };
    _this.handleTransitionEnd = function (evt) {
      if (evt.target === _this.outerRef && evt.propertyName === 'height') {
        if (_this.state.childrenLeaving) {
          _this.setState({
            children: null,
            childrenLeaving: false
          }, function () {
            return _this.endTransition();
          });
        } else {
          _this.endTransition();
        }
      }
    };
    _this.state = {
      children: props.children,
      childrenLeaving: false
    };
    return _this;
  }
  var _proto = SlideDownContent.prototype;
  _proto.componentDidMount = function componentDidMount() {
    if (this.outerRef) {
      if (this.props.closed || !this.props.children) {
        this.outerRef.classList.add('closed');
        this.outerRef.style.height = '0px';
      } else if (this.props.transitionOnAppear) {
        this.startTransition('0px');
      } else {
        this.outerRef.style.height = 'auto';
        this.outerRef.style.display = 'block';
      }
    }
  };
  _proto.getSnapshotBeforeUpdate = function getSnapshotBeforeUpdate() {
    /* Prepare to resize */
    return this.outerRef ? this.outerRef.getBoundingClientRect().height + 'px' : null;
  };
  SlideDownContent.getDerivedStateFromProps = function getDerivedStateFromProps(props, state) {
    if (props.children) {
      return {
        children: props.children,
        childrenLeaving: false
      };
    } else if (state.children) {
      return {
        children: state.children,
        childrenLeaving: true
      };
    } else {
      return null;
    }
  };
  _proto.componentDidUpdate = function componentDidUpdate(_prevProps, _prevState, snapshot) {
    if (this.outerRef) {
      this.startTransition(snapshot || '');
    }
  };
  _proto.startTransition = function startTransition(prevHeight) {
    var _this$outerRef3;
    var endHeight = '0px';
    var offsetHeightValue;
    if (!this.props.closed && !this.state.childrenLeaving && this.state.children) {
      var _this$outerRef;
      (_this$outerRef = this.outerRef) === null || _this$outerRef === void 0 ? void 0 : _this$outerRef.classList.remove('closed');
      this.outerRef.style.height = 'auto';
      this.outerRef.style.display = 'block';
      endHeight = getComputedStyle(this.outerRef).height;
    }
    if (parseFloat(endHeight).toFixed(2) !== parseFloat(prevHeight).toFixed(2)) {
      var _this$outerRef2;
      (_this$outerRef2 = this.outerRef) === null || _this$outerRef2 === void 0 ? void 0 : _this$outerRef2.classList.add('transitioning');
      this.outerRef.style.height = prevHeight;
      offsetHeightValue = this.outerRef.offsetHeight; // force repaint
      this.outerRef.style.transitionProperty = 'height';
      this.outerRef.style.height = endHeight;
    }
    if (offsetHeightValue === 1) (_this$outerRef3 = this.outerRef) === null || _this$outerRef3 === void 0 ? void 0 : _this$outerRef3.classList.remove('showtransitioning');
  };
  _proto.endTransition = function endTransition() {
    var _this$outerRef4;
    (_this$outerRef4 = this.outerRef) === null || _this$outerRef4 === void 0 ? void 0 : _this$outerRef4.classList.remove('transitioning');
    this.outerRef.style.transitionProperty = 'none';
    this.outerRef.style.height = this.props.closed ? '0px' : 'auto';
    if (this.props.closed || !this.state.children) {
      var _this$outerRef5;
      (_this$outerRef5 = this.outerRef) === null || _this$outerRef5 === void 0 ? void 0 : _this$outerRef5.classList.add('closed');
    }
  };
  _proto.render = function render() {
    var _this$props = this.props,
      _this$props$as = _this$props.as,
      as = _this$props$as === void 0 ? 'div' : _this$props$as,
      children = _this$props.children,
      className = _this$props.className,
      closed = _this$props.closed,
      transitionOnAppear = _this$props.transitionOnAppear,
      forwardedRef = _this$props.forwardedRef,
      rest = _objectWithoutPropertiesLoose(_this$props, _excluded);
    var containerClassName = className ? 'react-slidedown ' + className : 'react-slidedown';
    return /*#__PURE__*/React.createElement(as, _extends({
      ref: this.handleRef,
      className: containerClassName,
      onTransitionEnd: this.handleTransitionEnd
    }, rest), this.state.children);
  };
  return SlideDownContent;
}(Component);
SlideDownContent.defaultProps = {
  transitionOnAppear: true,
  closed: false
};
export var SlideDown = /*#__PURE__*/forwardRef(function (props, ref) {
  return (
    /*#__PURE__*/
    // @ts-ignore
    React.createElement(SlideDownContent, _extends({}, props, {
      forwardedRef: ref
    }))
  );
});
export default SlideDown;